import React from 'react';
import { YELLOW } from '../components/Theme/palette';

/**
 * The one "careful now" button look: for actions that are neither the primary step nor
 * destructive - notifying the customer, unassigning a job. The yellow group of the status colours
 * (the On hold amber): its soft fill, strong text and strong-light border. Keeping them identical
 * stops the screen collecting a different shade per action.
 */
export const cautionButtonStyle: React.CSSProperties = {
  backgroundColor: YELLOW.soft,
  borderColor: YELLOW.badge,
  color: YELLOW.tag,
};
